import { render, staticRenderFns } from "./VmStateBadge.vue?vue&type=template&id=084011e7&"
import script from "./VmStateBadge.vue?vue&type=script&lang=js&"
export * from "./VmStateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports